import React, { useState, useEffect } from "react";
import { useAsyncResponseHtml } from "./JobStatusHooks";
import { fetchJson } from "../../lib/Fetching";

export default function AsyncResponse({ url }) {
  const [asyncResponse, setAsyncResponse] = useState({});
  const { html } = useAsyncResponseHtml({ asyncResponse });

  useEffect(
    () => {
      fetchJson(url, {})
        .then((asyncResponse) => {
          setAsyncResponse(asyncResponse);
        })
        .catch((msg) => {
          alert("There was an error loading this page");
        });
    },
    [url]
  );

  if (!html)
    return (
      <div>
        <i className="fa fa-spinner fa-spin" />
        &nbsp; Loading...
      </div>
    );

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
